import React from "react";
import * as Yup from "yup";
import yupSchema from "../../../constants/schema";
import { useErrorHandler } from "../../../hooks";
import DialogFormBuilder from "../../../components/dialog-form-builder";
import couponService from "../../../services/coupon.service";

const initialValues = {
  name: "",
  prefix: "",
  count: 0,
  isActive: true,
  onlyApp: false,
};
const schema = Yup.object().shape({
  name: yupSchema.name,
  discount: yupSchema.discountPercent,
});
const form = [
  {
    _type: "textField",
    name: "name",
    label: "عنوان",
    autoFocus: true,
  },
  {
    _type: "textField",
    name: "prefix",
    label: "پیش کد",
  },
  {
    _type: "textField",
    name: "discount",
    label: "تخفیف ٪",
    type: "number",
    inputProps: {
      min: 0,
      max: 100,
    },
  },
  {
    _type: "textField",
    name: "count",
    label: "تعداد",
    type: "number",
    inputProps: {
      min: 0
    },
  },
  {
    _type: "switch",
    name: "onlyApp",
    label: "فقط اپلیکیشن",
  },
  {
    _type: "switch",
    name: "singleUse",
    label: "یکبارمصرف",
  },
];

export default function CreateGroupCouponModal({ close, data, extra }) {
  const errorHandler = useErrorHandler();

  const handleSubmit = async (model, { setSubmitting }) => {
    let op = await couponService.createGroupCoupon(model);
    const { error } = op;
    setSubmitting(false);
    if (error) return errorHandler(error);

    close(true);
  };

  return (
    <DialogFormBuilder
      {...{
        close,
        name: "کدتخفیف گروهی",
        data,
        schema,
        initialValues: {
            ...initialValues,
            ...data
        },
        handleSubmit,
        form,
      }}
    />
  );
}
